import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, ControlValueAccessor, FormControl } from '@angular/forms';
import { PageBuilderTextboxModel } from '../page-builder-textbox.model';

@Component({
    selector: 'abw-page-builder-textbox-form',
    providers: [
      {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => PageBuilderTextboxFormComponent),
        multi: true
      },
      {
        provide: NG_VALIDATORS,
        useExisting: forwardRef(() => PageBuilderTextboxFormComponent),
        multi: true
      }
    ],
    templateUrl: './page-builder-textbox-form.component.html',
    styleUrls: ['./page-builder-textbox-form.component.scss']
})
export class PageBuilderTextboxFormComponent implements ControlValueAccessor {
    @Input() model: PageBuilderTextboxModel;
    @Input() value: string;

    propagateChange = (_: any) => {};
    registerOnChange(fn) { this.propagateChange = fn; }
    registerOnTouched() {}
    writeValue(value: string) {
        this.value = value; 
    }

	validate({ value }: FormControl) {
		const isValid = (this.model as any).required && !value;
		return isValid && {
		  	invalid: true
		};
	}

  onInputChanged(event: any) {
    this.value = event.target.value;
    this.propagateChange(event.target.value);
  }
}